import { useSyncExternalStore } from 'react';

/**
 * React 19 native useMediaQuery hook using useSyncExternalStore.
 * Provides instantaneous, synchronous evaluation of CSS media queries without
 * legacy matchmediaquery wrappers or hydration delays.
 */
export function useMediaQuery(settings: string | { query: string }): boolean {
  const query = typeof settings === 'string' ? settings : settings.query;

  return useSyncExternalStore(
    (callback) => {
      if (typeof window === 'undefined') return () => {};
      const mql = window.matchMedia(query);
      mql.addEventListener('change', callback);
      return () => {
        mql.removeEventListener('change', callback);
      };
    },
    () => (typeof window !== 'undefined' ? window.matchMedia(query).matches : false),
    () => false
  );
}

export default useMediaQuery;
